<template>
  <section class="container">
    <div class="shopping-failed">
      <Progress :step.sync="step" />

      <div class="shopping-failed__content">
        <div class="shopping-failed__icon">
          <i class="el-icon-close"></i>
        </div>
        <h2 class="shopping-failed__title">{{ $t('shopping.status.paymentFailed') }}</h2>
        <div class="shopping-failed__info">
          <div class="shopping-failed__row">
            <span class="shopping-failed__label">{{ $t('shopping.label.orderNumber') }}:</span>
            <span class="shopping-failed__value">{{ orderNo }}</span>
          </div>
          <div class="shopping-failed__row">
            <span class="shopping-failed__label">{{ $t('shopping.label.orderStatus') }}:</span>
            <span class="shopping-failed__value shopping-failed__value--error">
              {{ $t('shopping.status.paymentFailed') }}
            </span>
          </div>
        </div>
        <p class="shopping-failed__message">
          {{ $t('shopping.message.contactSupport') }}
        </p>
      </div>

      <div class="shopping-failed__actions">
        <router-link
          class="shopping-failed__button"
          to="/member/orders"
        >
          <i class="el-icon-document"></i>
          {{ $t('shopping.button.viewOrders') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import Progress from '@/components/Shopping/Progress.vue';

export default {
  components: {
    Progress,
  },
  data() {
    return {
      step: 3,
      orderNo: '',
      errorCode: '',
    };
  },
  created() {
    const { i, c } = this.$route.query;
    this.orderNo = i;
    this.errorCode = c;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.shopping-failed {
  &__content {
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-lighter);
    padding: 48px 32px;
    text-align: center;
    margin: 32px 0;

    @media (max-width: $breakpoint-sm) {
      padding: 32px 20px;
    }
  }

  &__icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(245, 108, 108, 0.1);
    border-radius: 50%;

    i {
      font-size: 48px;
      color: var(--danger-color);
    }
  }

  &__title {
    font-size: var(--font-size-xl);
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 24px 0;
  }

  &__info {
    background-color: var(--background-light);
    border-radius: var(--border-radius-base);
    padding: 24px;
    margin: 24px 0;
    text-align: left;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid var(--border-lighter);

    &:last-child {
      border-bottom: none;
    }

    @media (max-width: $breakpoint-xs) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  &__label {
    font-size: var(--font-size-sm);
    color: var(--text-secondary);
    font-weight: 600;
  }

  &__value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    font-weight: 500;

    &--error {
      color: var(--danger-color);
    }
  }

  &__message {
    font-size: var(--font-size-base);
    color: var(--text-regular);
    margin: 24px 0 0 0;
    line-height: 1.6;
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin-top: 32px;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 48px;
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--text-white);
    background-color: var(--primary-color);
    border: none;
    border-radius: var(--border-radius-base);
    text-decoration: none;
    cursor: pointer;
    transition: all var(--transition-base);

    i {
      font-size: 18px;
    }

    &:hover {
      background-color: #0099d8;
      transform: translateY(-2px);
    }

    @media (max-width: $breakpoint-sm) {
      width: 100%;
      justify-content: center;
      padding: 12px 32px;
    }
  }
}
</style>
